import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const CaldavDialog = ({ open, onOpenChange, onSaved }) => {
  const { me } = useAuth();
  const email = me?.user?.email || me?.email || "";
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) { return; }
    api.get("/calendar/caldav").then((r) => {
      const a = r.data.account;
      setF({ url: a?.url || `https://syncdav.aruba.it/calendars/${email}/`, username: a?.username || email, password: "", saved: !!a });
    }).catch((e) => { toast.error(errorMessage(e)); onOpenChange(false); });
  }, [open, email, onOpenChange]);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put("/calendar/caldav", { url: f.url.trim(), username: f.username.trim(), password: f.password || null });
      toast.success(`Calendario «${r.data.calendar_name}» collegato`);
      onOpenChange(false); onSaved();
    } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  const remove = async () => {
    setBusy(true);
    try { await api.delete("/calendar/caldav"); toast.success("Calendario scollegato"); onOpenChange(false); onSaved(); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  const field = (k, l, type = "text") => (
    <div className="space-y-1.5"><Label className="text-xs">{l}</Label>
      <Input type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`caldav-input-${k}`} /></div>
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="caldav-dialog">
        <DialogHeader>
          <DialogTitle>Collega il tuo calendario</DialogTitle>
          <DialogDescription>Calendario CalDAV della tua casella (es. Aruba: https://syncdav.aruba.it/calendars/tuaemail/). Appuntamenti, interventi e scadenze del CRM finiscono qui e i tuoi impegni compaiono in Agenda. La password resta cifrata.</DialogDescription>
        </DialogHeader>
        {f && <div className="space-y-3">
          {field("url", "Indirizzo del calendario")}
          {field("username", "Utente (di solito l'email completa)")}
          {field("password", f.saved ? "Password (vuoto = invariata)" : "Password", "password")}
        </div>}
        <DialogFooter className="gap-2 sm:justify-between">
          {f?.saved ? <Button variant="ghost" onClick={remove} disabled={busy} className="text-red-600" data-testid="caldav-remove">Scollega</Button> : <span />}
          <Button onClick={save} disabled={busy || !f?.url || !f?.username} data-testid="caldav-save">{busy ? "Verifica in corso…" : "Collega e verifica"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
